import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TimetableJobResponseDto } from "../../shared/dtos/timetableJob/TimetableJobResponseDto";

export interface TimetableJobState {
  activeJob: TimetableJobResponseDto | null;
  loadingJobStart: boolean;
  loadingJobStatus: boolean;
  errorStartingJob: string | null;
  errorLoadingStatus: string | null;
}

const initialState: TimetableJobState = {
  activeJob: null,
  loadingJobStart: false,
  loadingJobStatus: false,
  errorStartingJob: null,
  errorLoadingStatus: null,
};

export const timetableJobSlice = createSlice({
  name: "timetableJob",
  initialState,
  reducers: {
    setLoadingJobStart(state) {
      state.loadingJobStart = true;
      state.errorStartingJob = null;
      state.activeJob = null;
    },
    startJobSuccess(state, action: PayloadAction<TimetableJobResponseDto>) {
      state.loadingJobStart = false;
      state.activeJob = action.payload;
    },
    setErrorStartingJob(state, action: PayloadAction<string | null>) {
      state.loadingJobStart = false;
      state.errorStartingJob = action.payload;
    },

    setLoadingJobStatus(state) {
      state.loadingJobStatus = true;
    },
    updateJobStatusSuccess(
      state,
      action: PayloadAction<TimetableJobResponseDto>,
    ) {
      state.loadingJobStatus = false;
      state.errorLoadingStatus = null;
      state.activeJob = action.payload;
    },
    setErrorLoadingStatus(state, action: PayloadAction<string | null>) {
      state.loadingJobStatus = false;
      state.errorLoadingStatus = action.payload;
    },

    resetTimetableJobState() {
      return initialState;
    },
  },
});

export const timetableJobActions = timetableJobSlice.actions;
export default timetableJobSlice.reducer;
